module.exports = __webpack_public_path__ + "static/img/cabinet5_4.30393de4.gif";